module.exports = __webpack_public_path__ + "img/bitcoin-logo.01ce34c0.svg";